import React from 'react'
import { socialMedia } from "./Social";

const Footer = () => {
  return (
    <div className="w-full bg-gradient-to-t from-cyan-400 flex justify-between items-center md:flex-row flex-col p-3 pl-10 pr-10 pt-6 -mt-1 ">
      <p className=" font-semibold text-center text-[13px] font-serif leading-[27px] text-gray-900">
      © 2024 __SasTik™. All Rights Reserved💖.
      </p>
      <div className="flex flex-row md:mt-0 mt-6">
        {socialMedia.map((Social, index) => (
          <a href={Social.link}>
          <img
            key={Social.id}
            src={Social.icon}
            alt={Social.id}
            className={`w-[21px] h-[21px] object-contain cursor-pointer animate-pulse ${
              index !== socialMedia.length - 1 ? "mr-6" : "mr-0"
            }`}
          /></a>
        ))}
      </div>
    </div>
  );
};

export default Footer;
